import React from "react";
import {
  QuestionContainer,
  TitleContainer,
  TextContainer,
} from "./index.styled";

import Accordion from "../accordion";

const Questions = () => {
  return (
    <QuestionContainer>
      <TitleContainer color="#12A46F" titleColor="#8C8D9B" textColor="#2D3134">
        <h5>پرسشهای متداول</h5>
        <TextContainer width="342px">
          <span></span>
          <p> پرسشهایی که بیشترین تکرار را داشته اند.</p>
        </TextContainer>
      </TitleContainer>
      <Accordion />
    </QuestionContainer>
  );
};

export default Questions;
